import { P } from "const/permissions";
import { hasPermissionKey, isSuperAdmin } from "utils/permissionUtils";

/**
 * Mirrors ReferrerAuthority on the backend: a client that came through the partner portal can only
 * be re-pointed by a super admin; anything else needs referral:attribution:assign. The backend is
 * the authority — this only decides what to show.
 */
export const needsSuperAdmin = (client) => client?.referralOrigin === "PORTAL";

export const canAssignReferrer = () => hasPermissionKey(P.REFERRAL.ATTRIBUTION_ASSIGN);

export const canChangeReferrer = (client) =>
  needsSuperAdmin(client) ? isSuperAdmin() : canAssignReferrer();
